import api from '../../../configs/instanceApi';

export const getAllQuestionsPartners = (ecIdentity) => {
  const url = `/accreditation-quotations/qsa/${ecIdentity}`;
  return api.get(url);
};

export const sendPartnerAnswer = (
  ecIdentity,
  idQuestion,
  idPartner,
  answer,
  recaptchaToken = ''
) => {
  const param = `${ecIdentity}/partners?idQuestion=${idQuestion}&idPartner=${idPartner}`;
  const url = `/accreditation-quotations/quotations/${param}`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, answer, config);
};

export const isPartnerAnswer = (ecIdentity, answer, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/user-partner`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, answer, config);
};
